/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactResponseDtoSchema } from "./contactResponseDtoSchema";
import { z } from "zod/v4";

export const batchCreateContactResultDtoSchema = z.object({
    "index": z.number().describe("Position of this contact in the request array"),
"success": z.boolean(),
get "contact"(){
                return contactResponseDtoSchema.optional()
              },
"error": z.optional(z.string())
    })